export default async function courseDownload (url) {
  window.open(url)
}
